/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { LuisText, LuisTextProps } from 'src/core/components/LuisText';
import { Page, PageProps } from 'src/core/components/Page';
import { getStylistV2 } from 'src/core/themes/luisStylist';

export type ErrorTextContainerProps = {
    /**
     * Title of the error.
     */
    title: string;
    /**
     * Subtitle of the error.
     */
    subTitle: string;
};

const { styleComponent } = getStylistV2('SamplingTrackers');
const MainText = styleComponent<LuisTextProps>(LuisText)('MainText', theme => ({ marginBottom: theme.textMargin }));

/**
 * A small wrapper around the page component to
 * avoid duplication.
 */
const Container = (props: React.PropsWithChildren<PageProps>) => {
    const { children, ...rest } = props;

    return (
        <Page {...rest} size="container-fluid" animateIn={false}>
            {children}
        </Page>
    );
};

/**
 * Container to hold errors.
 */
export const ErrorTextContainer = (props: ErrorTextContainerProps) => {
    const { subTitle, title } = props;

    return (
        <Container pageName="ErrorTextContainerPage">
            <MainText variant="xLargePlus" block>
                {title}
            </MainText>

            <LuisText variant="large" block>
                {subTitle}
            </LuisText>
        </Container>
    );
};
